import React from 'react';
import { AppPlatform, AppStoreType } from '../../types';
import Space from 'antd/lib/space';
import { displayTextForReleaseStepType } from '../../helpers/displayHelpers';
import Text from 'antd/lib/typography/Text';
import { StepGraphStep } from '@/types/workflow';
import Divider from 'antd/lib/divider';

interface InlineStepConfigDescriptionProps {
    stepGraphStep: StepGraphStep;
    platform: AppPlatform;
    appStoreType: AppStoreType;
    isWorkflowsCIStepEnabled: boolean;
}

export const InlineStepConfigDescription: React.FC<InlineStepConfigDescriptionProps> = ({
    stepGraphStep,
    platform,
    appStoreType,
    isWorkflowsCIStepEnabled,
}) => {
    return (
        <Space
            style={{
                padding: '0 8px',
            }}
            size={2}
            split={
                <Divider
                    type={'vertical'}
                    style={{
                        height: 20,
                    }}
                />
            }
        >
            <Text type="secondary">
                {displayTextForReleaseStepType(
                    stepGraphStep.archetype,
                    platform,
                    appStoreType,
                    isWorkflowsCIStepEnabled,
                )}
            </Text>
            <Text>{stepGraphStep.stepName}</Text>
        </Space>
    );
};
